import _defineProperty from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { defineIntegration, convertIntegrationFnToClass } from '@sentry/core';
var INTEGRATION_NAME = 'SessionTiming';
var _sessionTimingIntegration = function _sessionTimingIntegration() {
  var startTime = Date.now();
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent: function processEvent(event) {
      var now = Date.now();
      return _objectSpread({}, event, {
        extra: _objectSpread({}, event.extra, _defineProperty(_defineProperty(_defineProperty({}, 'session:start', startTime), 'session:duration', now - startTime), 'session:end', now))
      });
    }
  };
};
var sessionTimingIntegration = defineIntegration(_sessionTimingIntegration);

/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
var SessionTiming = convertIntegrationFnToClass(INTEGRATION_NAME, sessionTimingIntegration);
export { SessionTiming, sessionTimingIntegration };